import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {
    extendedStyles?: FooterContainerStyles;
}

export interface FooterContainerStyles {
    widgetGridContainer?: GridContainerProps;
    logoGridItem?: GridItemProps;
    linkList1GridItem?: GridItemProps;
    linkList2GridItem?: GridItemProps;
    linkList3GridItem?: GridItemProps;
    linkList4GridItem?: GridItemProps;

    subscribeGridItem?: GridItemProps;
    socialLinksGridItem?: GridItemProps;
    siteMapLinksGridItem?: GridItemProps;
    richContentGridItem?: GridItemProps;
    logoWrapper?: InjectableCss;
}

export const footerContainerStyles: FooterContainerStyles = {
    widgetGridContainer: {
        css: css`
            color: ${getColor("primary.contrast")};
            margin: 0 auto;
            div[class^="GridOffset"] {
                max-width: 100%;
                margin: 0 auto;
                background-color: #252129;
            }
        `,
    },
    linkList1GridItem: {
        width: [6, 6, 3, 3, 3],
        css: css`
        div.title-wrapper {
            span{
                color: ${getColor("primary.contrast")};
                font-weight: 600;
                font-size: 18px;
            }
        }
        div.links-wrapper {
            a.list-link {
                span{
                    color: ${getColor("primary.contrast")};
                    text-transform: none;
                    font-size: 13px;
                    font-weight: 500;
                }
                &:hover span {
                    color: ${getColor("primary")};
                }
            }
        }
    `,
    },
    linkList2GridItem: {
        width: [6, 6, 3, 3, 3],
        css: css`
        div.title-wrapper {
            span{
                color: ${getColor("primary.contrast")};
                font-weight: 600;
                font-size: 18px;
            }
        }
        div.links-wrapper {
            a.list-link {
                span{
                    color: ${getColor("primary.contrast")};
                    text-transform: none;
                    font-size: 13px;
                }
                &:hover span {
                    color: ${getColor("primary")};
                }
            }
        }
    `,
    },
    linkList3GridItem: {
        width: [6, 6, 3, 3, 3],
        css: css`
        div.title-wrapper {
            span{
                color: ${getColor("primary.contrast")};
                font-weight: 600;
                font-size: 18px;
            }
        }
        div.links-wrapper {
            a.list-link {
                span{
                    color: ${getColor("primary.contrast")};
                    text-transform: none;
                    font-size: 13px;
                }
                &:hover span {
                    color: ${getColor("primary")};
                }
            }
        }
    `,  
    },
    linkList4GridItem: {
        width: [6, 6, 3, 3, 3],
        css: css`
        div.title-wrapper {
            span{
                color: ${getColor("primary.contrast")};
                font-weight: 600;
                font-size: 18px;
            }
        }
        div.links-wrapper {
            a.list-link {
                span{
                    color: ${getColor("primary.contrast")};
                    text-transform: none;
                    font-size: 13px;
                }
                &:hover span {
                    color: ${getColor("primary")};
                }
            }
        }
    `,
    },
    subscribeGridItem: {
        width: [12, 12, 8, 4, 4],
    },
    socialLinksGridItem: {
        width: 12,
    },
    siteMapLinksGridItem: {
        width: 12,
    },
    richContentGridItem: {
        width: 12,
        css: css`
            border-top: 3px solid white;
            p[class^="TypographyStyle"]{
                font-size: 13px;
                text-align: center;
            }
        `,
    },
    logoWrapper: {
        css: css`
            width: 110px;
        `,
    },
};

const FooterContainer: FC<OwnProps> = ({ id, extendedStyles }) => {
    const [styles] = React.useState(() => mergeToNew(footerContainerStyles, extendedStyles));
    return (
        <GridContainer {...styles.widgetGridContainer}>
            <GridItem {...styles.linkList1GridItem}>
                <Zone zoneName="LinkList1" contentId={id} />
            </GridItem>
            <GridItem {...styles.linkList2GridItem}>
                <Zone zoneName="LinkList2" contentId={id} />
            </GridItem>
            <GridItem {...styles.linkList3GridItem}>
                <Zone zoneName="LinkList3" contentId={id} />
            </GridItem>
            <GridItem {...styles.linkList4GridItem}>
                <Zone zoneName="LinkList4" contentId={id} />
            </GridItem>
            <GridItem {...styles.socialLinksGridItem}>
                <Zone zoneName="SocialLinks" contentId={id} />
            </GridItem>
            <GridItem className="Copyright" {...styles.richContentGridItem}>
                <Zone zoneName="RichContent" contentId={id} />
            </GridItem>
        </GridContainer>
    );
};

const footerContainer: WidgetModule = {
    component: FooterContainer,
    definition: {
        group: "Footer",
        allowedContexts: ["Footer"],
    },
};

export default footerContainer;
